import React from "react";
import { createPortal } from "react-dom";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

const UserConfirmDialog = ({
    show,
    title,
    text,
    details = [],
    dangerAction = null,
    secondaryAction = null,
    primaryAction = null,
    busy = false,
}) => {
    if (!show || typeof document === "undefined") return null;

    const actionCount = [dangerAction, secondaryAction, primaryAction].filter(Boolean).length;

    const renderButton = (action, className, icon = null) => {
        if (!action) return null;

        return (
            <button
                type="button"
                className={className}
                onClick={action.onClick}
                disabled={busy || action.disabled}
            >
                {icon}
                <span>{action.label}</span>
            </button>
        );
    };

    return createPortal(
        <div className="userConfirmDialog" role="dialog" aria-modal="true">
            <div className="userConfirmDialog__overlay" />
            <div className="userConfirmDialog__box">
                <div className="userConfirmDialog__icon">
                    <WarningAmberIcon />
                </div>

                <strong className="userConfirmDialog__title">{title}</strong>
                <p className="userConfirmDialog__text">{text}</p>

                {Array.isArray(details) && details.length ? (
                    <div className="userConfirmDialog__changes">
                        <b>Что изменено:</b>
                        <div>
                            {details.map((item, index) => (
                                <section key={`${item.label || "change"}-${index}`}>
                                    <span>{item.label || "Изменение"}</span>
                                    {Object.prototype.hasOwnProperty.call(item, "before") ? (
                                        <p><em>Было:</em> {String(item.before ?? "—")}</p>
                                    ) : null}
                                    {Object.prototype.hasOwnProperty.call(item, "after") ? (
                                        <p><em>Стало:</em> {String(item.after ?? "—")}</p>
                                    ) : null}
                                </section>
                            ))}
                        </div>
                    </div>
                ) : null}

                <div className={`userConfirmDialog__actions is-${actionCount}`}>
                    {renderButton(dangerAction, "is-danger")}
                    {renderButton(secondaryAction, "is-secondary")}
                    {renderButton(
                        primaryAction,
                        "is-primary",
                        primaryAction ? <SaveOutlinedIcon sx={{ fontSize: 17 }} /> : null
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default UserConfirmDialog;
